/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        key: "tips",
        value: "链接可以拖拽改变顺序",
        type: "tips"
    },
    {
        name: "拼团",
        type: "module-name"
    },
    {
        key: "style_type",
        name: "样式",
        type: "radio-box-img",
        width: 84,
        "radio-list": [{
                url: "https://img.mockuai.com/tms/2018/1/10/upload_45d9acc229960a30ca9b14ab951d0986.png",
                value: 1,
                text: "双列无边距"
            },
            {
                url: "https://img.mockuai.com/tms/2018/1/10/upload_45d9acc229960a30ca9b14ab951d0986.png",
                value: 2,
                text: "双列有边距"
            },
            {
                url: "https://img.mockuai.com/tms/2018/1/10/upload_c9b8a668b7812c4277a638986eab1e93.png",
                value: 3,
                text: "单列无间距"
            },
            {
                url: "https://img.mockuai.com/tms/2018/1/10/upload_c9b8a668b7812c4277a638986eab1e93.png",
                value: 4,
                text: "单列有间距"
            },
            {
                url: "https://img.mockuai.com/tms/2018/1/10/upload_337f6d48a136bd004a3cee76b951572f.png",
                value: 5,
                text: "大图单列"
            }
        ]
    },
    {
        key: "link_data",
        name: "链接",
        type: "form-group-list"
    }
];

export default config;